import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { recentBuyers, purchaseTimes } from "../data/content";
type Notice = {
  name: string;
  country: string;
  time: string;
};
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * recentBuyers.length);
    let hideTimer: number | undefined;
    const show = () => {
      const buyer = recentBuyers[index % recentBuyers.length];
      index += 1;
      setNotice({
        name: buyer.name,
        country: buyer.country,
        time: purchaseTimes[Math.floor(Math.random() * purchaseTimes.length)]
      });
      hideTimer = window.setTimeout(() => setNotice(null), SHOW_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-0 top-3 z-50 flex justify-center px-3 sm:inset-x-auto sm:bottom-6 sm:left-6 sm:top-auto sm:justify-start sm:px-0" data-id="element-237" data-mp="1awpm9t25hwkq">
      <AnimatePresence data-id="element-238" data-mp="n7d9ykbj18e7">
        {notice && !dismissed && <motion.div key={notice.name + notice.time} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} role="status" className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-ink/10 bg-white p-3 pr-2 shadow-[0_12px_32px_-8px_rgba(7,20,42,0.35)]" data-id="element-239" data-mp="i93hihh6slwa">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cta font-display text-lg font-black text-white" data-id="element-240" data-mp="2ao1lwul5njo6">
              {notice.name.charAt(0)}
            </span>
            <div className="min-w-0 flex-1" data-id="element-241" data-mp="2knah1qrrb4c4">
              <p className="text-sm leading-snug text-ink" data-id="element-242" data-mp="2plk8pre9vmsz">
                <strong data-id="element-243" data-mp="2pl2f72izvmor">{notice.name}</strong> from <strong data-id="element-244" data-mp="1rybt2d0yd7yw">{notice.country}</strong> just purchased the{" "}
                <strong data-id="element-245" data-mp="1rvz59j8ik3dx">CAN Bus Diagnostic Blueprint™</strong>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-ink-muted" data-id="element-246" data-mp="1wxod6q0fw0xs">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-cta" aria-hidden="true" data-id="element-247" data-mp="21vhkxnhe5306" />
                Verified purchase · {notice.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-ink-muted transition-colors duration-150 ease-out hover:bg-canvas hover:text-ink" data-id="element-248" data-mp="1983wkdrrdfro">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-249" data-mp="3nfv11185sqgi" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}